// extracted by mini-css-extract-plugin
module.exports = {"favorite":"styles-module__favorite___1X82M","selected":"styles-module__selected___3GQLo","onWhiteBg":"styles-module__onWhiteBg___3Tqjs"};